import { render } from "./imgView.vue?vue&type=template&id=4031b678&ts=true"
import script from "./imgView.vue?vue&type=script&lang=ts"
export * from "./imgView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__